import React, { lazy, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { getCustomerList, getCompanyId } from "apis/user";
import * as qs from "query-string";
import cookies from "js-cookie";
import {
  setRequestCompanyId,
  removeRequestCompanyId
} from "pages/myutils/request";
import {
  getEnvUrl,
  wjbCustomerTestDomain,
  wjbCustomerProductionDomain
} from "../context/env.js";

const { companyid } = qs.parse(window.location.search);
const toSettlement = () => {
  window.open(
    getEnvUrl([
      wjbCustomerTestDomain,
      wjbCustomerProductionDomain,
      "/settlement",
      false,
      true,
      false
    ]),
    "_blank"
  );
};
const toTelAccount = () => {
  window.open(
    getEnvUrl([
      wjbCustomerTestDomain,
      wjbCustomerProductionDomain,
      "/settlement",
      false,
      true,
      "#/telAccount"
    ]),
    "_blank"
  );
};
const pages = {
  prefix: "/company",
  init: function Init({ user }) {
    console.log("company输出", user);
    useEffect(() => {
      getCompanyId().then(datas => {
        if (datas.id > 0 && companyid * 1 !== datas.id) {
          window.location.href =
            window.location.pathname + "?companyid=" + datas.id;
        } else if (datas.id <= 0) {
          // <Redirect to="/index" />;
          window.location.href = "/user/workbench/home";
        }
      });
      if (user.self.company) {
        setRequestCompanyId(user.self.company.companyId);
      }
      return () => {
        removeRequestCompanyId();
      };
    }, []);

    // if (!user.self.company) {
    //   return <Redirect to="/index" />;
    // }

    return null;
  },
  pages: [
    {
      path: "/company/staff",
      name: "员工管理",
      children: [
        {
          path: "/company/staff/list",
          name: "员工列表",
          component: lazy(() => import("./staff/staffList"))
        },
        {
          path: "/company/staff/adminlist",
          name: "管理员列表",
          noNav: true,
          component: lazy(() => import("./admin/adminList"))
        },
        {
          path: "/company/staff/staffrole",
          name: "定向发布角色管理",
          // noNav: true,
          component: lazy(() => import("./staff/staffRole"))
        }
      ]
    },
    {
      path: "/company/funds",
      name: "企业钱包",
      children: [
        {
          path: "/company/funds/list",
          name: "账户流水",
          component: lazy(() => import("./funds/fundsList"))
        },
        {
          path: "/company/funds/textmessage",
          name: "短信管理",
          component: lazy(() => import("./funds/fundmess"))
        },
        {
          path: "/company/funds/settlement",
          name: "结算账户",
          open: true, // 参数控制是否自定义跳转
          openLink: toSettlement // 自定义跳转函数
          // component: lazy(() => import("./funds/settlement"))
        }
        // {
        //   path: "/company/funds/telAccount",
        //   name: "电话访问流水",
        //   open: true, // 参数控制是否自定义跳转
        //   openLink: toTelAccount // 自定义跳转函数
        //   // component: lazy(() => import("./funds/settlement"))
        // }
      ]
    },
    {
      path: "/company/setting",
      name: "企业设置",
      // component: lazy(() => import("./setting"))
      children: [
        {
          path: "/company/setting/set",
          name: "企业设置",
          component: lazy(() => import("./setting/set"))
        }
        // {
        //   path: "/company/setting/encyclopedias",
        //   name: "企业百科",
        //   component: lazy(() => import("pages/manager/workbench/encyclopedias"))
        // }
      ]
    }
    // {
    //   path: "/company/service",
    //   name: "服务设置",
    //   children: [
    //     {
    //       path: "/company/service",
    //       name: "服务设置",
    //       component: lazy(() => import("./service/serviceList"))
    //     }
    //   ]
    // }
    // {
    //   path: "/company/identify",
    //   name: "企业认证",
    //   noNav: true,
    //   children: [
    //     {
    //       path: "/company/identify",
    //       name: "企业认证",
    //       component: lazy(() =>
    //         import("../index/components/authentication/company")
    //       )
    //     }
    //   ]
    // }
    // {
    //   path: "/company/set",
    //   name: "企业设置",
    //   children: [
    //     {
    //       path: "/company/set/login",
    //       name: "登录页配置",
    //       component: lazy(() => import("./set/login"))
    //     },
    //     {
    //       path: "/company/set/icon",
    //       name: "网址图标配置",
    //       component: lazy(() => import("./set/icon"))
    //     },
    //     {
    //       path: "/company/set/register",
    //       name: "注册页配置",
    //       component: lazy(() => import("./set/register"))
    //     }
    //   ]
    // }
  ],
  startPage: ""
};
if (window.location.pathname.indexOf("/mymymanager") === -1) {
  getCustomerList({ token: cookies.get("shorcuts") }).then(data => {
    console.log(1111, data);
    data.map(x => {
      if (x.companyId === companyid * 1) {
        if (x.owner === 1) {
          pages.pages[0].children[1].noNav = false;
        }
      }
      return "";
    });
  });
}
pages.startPage = pages.pages[0].path;
export default pages;
